/**
 * Rotating purchase notification.
 *
 * Reads its items and timings from a JSON payload rendered by the section, shows them on a
 * timer, and stops once the configured cap is reached or the customer dismisses it.
 *
 * Installed once behind a guard and owns a single timer, so nothing accumulates if the markup
 * is ever re-rendered. Pauses while the tab is hidden.
 */
(function () {
  'use strict';

  if (window.__aquaPopupInstalled) return;
  window.__aquaPopupInstalled = true;

  var DISMISS_KEY = 'aqua-popup-dismissed';

  function init() {
    var root = document.getElementById('aqua-popup');
    var payloadEl = document.getElementById('aqua-popup-data');
    if (!root || !payloadEl) return;

    var config;
    try {
      config = JSON.parse(payloadEl.textContent || '{}');
    } catch (error) {
      return;
    }

    var items = (config.items || []).filter(function (item) {
      return item && item.title;
    });
    if (!items.length) return;

    try {
      if (sessionStorage.getItem(DISMISS_KEY) === '1') return;
    } catch (error) {
      /* storage unavailable - carry on */
    }

    var cities = config.cities && config.cities.length ? config.cities : ['Lahore'];
    var imgWrap = document.getElementById('aqua-popup-media');
    var metaEl = document.getElementById('aqua-popup-meta');
    var nameEl = document.getElementById('aqua-popup-name');
    var timeEl = document.getElementById('aqua-popup-time-text');
    var linkEl = document.getElementById('aqua-popup-link');
    var closeBtn = document.getElementById('aqua-popup-close');

    var shown = 0;
    var timer = null;
    var hideTimer = null;
    var order = shuffle(items.slice());
    var cursor = 0;

    function shuffle(list) {
      for (var i = list.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = list[i];
        list[i] = list[j];
        list[j] = tmp;
      }
      return list;
    }

    function pick() {
      // Cycle a shuffled order so the same item doesn't repeat back to back.
      if (cursor >= order.length) {
        order = shuffle(order);
        cursor = 0;
      }
      return order[cursor++];
    }

    function show() {
      if (document.hidden) return;
      if (shown >= config.maxNotifications) return stop();

      var item = pick();
      var city = cities[Math.floor(Math.random() * cities.length)];

      if (imgWrap) {
        imgWrap.innerHTML = '';
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title;
          img.className = 'aqua-popup__img';
          img.loading = 'lazy';
          img.width = 72;
          img.height = 72;
          imgWrap.appendChild(img);
        }
      }

      if (metaEl) metaEl.innerHTML = 'Someone in <strong></strong> just purchased';
      if (metaEl && metaEl.querySelector('strong')) metaEl.querySelector('strong').textContent = city;
      if (nameEl) nameEl.textContent = item.title;
      if (timeEl) timeEl.textContent = item.time || '';
      if (linkEl && item.url) linkEl.setAttribute('href', item.url);
      if (linkEl) linkEl.setAttribute('tabindex', '0');

      root.classList.add('is-visible');
      root.setAttribute('aria-hidden', 'false');
      shown++;

      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, config.duration);
    }

    function hide() {
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      if (linkEl) linkEl.setAttribute('tabindex', '-1');
    }

    function stop() {
      clearInterval(timer);
      clearTimeout(hideTimer);
      timer = null;
      hide();
    }

    closeBtn &&
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        stop();
        try {
          sessionStorage.setItem(DISMISS_KEY, '1');
        } catch (error) {
          /* storage unavailable */
        }
      });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearTimeout(hideTimer);
    });

    setTimeout(function () {
      show();
      timer = setInterval(show, config.interval);
    }, config.firstDelay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
